import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import '../../styles/carrusel.css';

function FotosClub() {
  const [fotos, setFotos] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedFoto, setSelectedFoto] = useState(null);

  useEffect(() => {
    api.get(`fotos/`)
      .then(response => {
        const fotosConUrl = response.data.map(foto => ({
          ...foto,
          src: foto.imagen,
          title: foto.titulo,
        }));
        setFotos(fotosConUrl);
      })
      .catch(error => console.error('Error fetching fotos:', error));
  }, []);

  // Navegar al anterior
  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? fotos.length - 1 : prevIndex - 1
    );
  };

  // Navegar al siguiente
  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === fotos.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Seleccionar una foto específica
  const handleSelectFoto = (index) => {
    setCurrentIndex(index);
  };

  // Abrir y cerrar el modal
  const openModal = (foto) => {
    setSelectedFoto(foto);
  };

  const closeModal = () => {
    setSelectedFoto(null);
  };

  // Navegar en el modal
  const handleModalPrev = () => {
    const currentFotoIndex = fotos.findIndex((foto) => foto.src === selectedFoto.src);
    const prevIndex = currentFotoIndex === 0 ? fotos.length - 1 : currentFotoIndex - 1;
    setSelectedFoto(fotos[prevIndex]);
  };

  const handleModalNext = () => {
    const currentFotoIndex = fotos.findIndex((foto) => foto.src === selectedFoto.src);
    const nextIndex = currentFotoIndex === fotos.length - 1 ? 0 : currentFotoIndex + 1;
    setSelectedFoto(fotos[nextIndex]);
  };

  if (fotos.length === 0) {
    return (
      <div className="page">
        <h1>Fotos del club</h1>
        <p>Cargando fotos...</p>
      </div>
    );
  }

  return (
    <div className="page">
      <h1>Fotos del club</h1>
      <p>Descubre nuestras instalaciones y el ambiente del Club Nexo.</p>

      {/* Carrusel con miniaturas */}
      <div className="carousel-container">
        <button className="carousel-button prev" onClick={handlePrev}>
          ❮
        </button>
        <div className="carousel">
          {fotos.map((foto, index) => (
            <div
              key={index}
              className={`carousel-item ${index === currentIndex ? 'active' : ''}`}
              onClick={() => {
                if (index === currentIndex) {
                  openModal(foto); // Abrir modal solo si es la foto activa
                } else {
                  handleSelectFoto(index); // Cambiar foto activa si es una miniatura
                }
              }}
            >
              <img
                src={foto.src}
                alt={foto.title}
                loading="lazy"
              />
              {index === currentIndex && (
                <div className="carousel-title">{foto.title}</div>
              )}
            </div>
          ))}
        </div>
        <button className="carousel-button next" onClick={handleNext}>
          ❯
        </button>
      </div>

      {/* Modal */}
      {selectedFoto && (
        <div className="modal">
          <div className="modal-content">
            <button className="modal-close" onClick={closeModal}>
              ✕
            </button>
            <button className="modal-button prev" onClick={handleModalPrev}>
              ❮
            </button>
            <img src={selectedFoto.src} alt={selectedFoto.title} />
            <button className="modal-button next" onClick={handleModalNext}>
              ❯
            </button>
            <div className="modal-title">{selectedFoto.title}</div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FotosClub;